export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

export const COMPANY_NAME    = 'JSISCO';
export const COMPANY_NAME_AR = 'شركة الجنوب للأنظمة المتكاملة';

export const PHONE_NUMBER    = '+962 3 213 1100';
export const WHATSAPP_NUMBER = '962779293100';
export const EMAIL           = 'info@jsisco.com';

export const ADDRESS_AR = 'ش. العقبة، معان، المملكة الأردنية الهاشمية 71110';
export const ADDRESS_EN = "Aqaba St., Ma'an, Jordan 71110";

export const SERVICE_AREAS_AR = ['محافظة الطفيلة', 'معان', 'الكرك', 'العقبة', 'عمّان'];
export const SERVICE_AREAS_EN = ['Tafilah Governorate', "Ma'an", 'Al Karak', 'Aqaba', 'Amman'];

export const SOCIAL_LINKS = {
  facebook:  'https://www.facebook.com/South.Integrated.Systems',
  instagram: 'https://instagram.com/jsisco',
  linkedin:  'https://www.linkedin.com/company/jsis-co',
  whatsapp:  'https://wa.me/962779293100',
};
